import React from 'react';
import ManualCreatePage from '../../domain/manual-editor';

export default function ManualCreate() {
  return <ManualCreatePage />;
}
